import { Data } from '@blade/std-lib'
import { SecureStorageErrorCode } from '@root/shared/ui/secure-storage-error-code'

import type { WalletOnDevice } from './secure-storage-service'
import type { SupportedErrorCode } from '@root/shared/ui'

export class SecureStorageError extends Data.TaggedError('SecureStorageError')<{
  method: string
  cause: unknown
}> {
  static fromUnknown = (externalError?: unknown): SecureStorageError => {
    if (externalError instanceof SecureStorageError) {
      return externalError
    }

    return new SecureStorageError({
      cause: undefined,
      method: 'empty',
    })
  }
}

export class WrongPasswordError extends Data.TaggedError(
  'WrongPasswordError',
) {}

export class WalletAlreadyExistsError extends Data.TaggedError(
  'WalletAlreadyExistsError',
)<{
  wallet: WalletOnDevice
}> {}

export class StorageAlreadyUnlockedError extends Data.TaggedError(
  'StorageAlreadyUnlockedError',
) {}

export const toSharedErrorCode = (
  error: SecureStorageError | WrongPasswordError | WalletAlreadyExistsError,
) => {
  switch (error._tag) {
    case 'SecureStorageError': {
      return error.cause as unknown as SupportedErrorCode
    }
    case 'WrongPasswordError': {
      return SecureStorageErrorCode.WrongPassword
    }
    case 'WalletAlreadyExistsError': {
      return SecureStorageErrorCode.AlreadyExistsAddress
    }
  }
}
